function initPerfectBannerSlider() {
  const el = document.querySelector('.perfect-banner-swiper');
  if (!el) return;

  // Clean old instances securely
  if (el.swiper) {
    el.swiper.destroy(true, true);
  }

  const slideCount = el.querySelectorAll('.swiper-slide').length;
  if (slideCount <= 1) {
    const dots = el.querySelector('.swiper-pagination');
    if (dots) dots.style.display = 'none';
    return;
  }

  const isAutoplay = el.getAttribute('data-autoplay') === 'true';
  const customSpeed = parseInt(el.getAttribute('data-speed'), 10);
  const slideDuration = (isNaN(customSpeed) || customSpeed <= 0) ? 4000 : customSpeed;

  let autoplayConfig = false;
  if (isAutoplay) {
    autoplayConfig = {
      delay: slideDuration,
      disableOnInteraction: false,
    };
  }

  // Lightweight Swiper runtime config initialization
  new Swiper('.perfect-banner-swiper', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 700, // Smooth transition pace speed rate
    autoplay: autoplayConfig,
    grabCursor: true,
    allowTouchMove: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    // Passive performance load properties configuration
    observer: false, 
    observeParents: false 
  });
}

// Global runtime execution events
document.addEventListener('DOMContentLoaded', initPerfectBannerSlider);

document.addEventListener('shopify:section:load', function(e) {
  if (e.target.querySelector('.perfect-banner-swiper')) {
    initPerfectBannerSlider();
  }
});

document.addEventListener('shopify:block:select', function(e) {
  if (e.target.closest('.perfect-banner-swiper')) {
    initPerfectBannerSlider();
  }
});